import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { ContactSchema, DealSchema } from '../../../definitions/schemas';
import { getProcessedName } from '../../../lib/Room';

interface Props {
  contact: ContactSchema | undefined;
  deal: DealSchema | undefined;
  name: string;
  variant?: TypographyProps['variant'];
}

const RoomName: React.FC<Props> = (props: Props): JSX.Element => {
  const { contact, deal, name, variant = 'h6' } = props;

  return (
    <Typography component="h1" color="textPrimary" variant={variant}>
      {getProcessedName(name, deal, contact)}
    </Typography>
  );
};

export default RoomName;
